import React from "react";
import { Link } from "react-router-dom";

const Sitemap = () => {
  return (
    <>
      {/* Header Banner Section */}
      <section
        className="ser_v_araeea green_bg manages_heis manages_top"
        id="about_pgs"
      >
        <img src="/images/flo_partss.png" className="flo_partss" alt="" />
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="al_sprts_pages">
                <h3>Site Map</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sitemap Section */}
      <section className="ser_v_araeea pt-0 bg-white ">
        <div className="sitemap-wrapper">
        <div className="container">

        <div className="bradcams" style={{ backgroundColor: "#efefef", padding: "3px 10px" }}>
            <span className="bothss">
              <Link to="/">Home</Link>{" "}
              <img src="/images/brd_rowwo.png" alt="" /> Sitemap
            </span>
          </div>
        <div className="sitemap-list">
          <div className="sitemap-section">
            <h3>Home</h3>
            <ul>
              <li><Link to="/">Home Page</Link></li>
            </ul>
          </div>

          <div className="sitemap-section">
            <h3>About Us</h3>
            <ul>
              <li><Link to="/about-us">Mission & Vision</Link></li>
              <li><Link to="/about-us">Our Story</Link></li>
              <li><Link to="/about-us">Team</Link></li>
            </ul>
          </div>

          <div className="sitemap-section">
            <h3>Donate</h3>
            <ul>
            <li><Link to="/donate-category/volunteer">Volunteer</Link></li>
            <li><Link to="/donate-category/education">Education</Link></li>
            <li><Link to="/donate">View all Categories</Link></li>
            </ul>
          </div>

         

          <div className="sitemap-section">
            <h3>Events</h3>
            <ul>
              <li><Link to="/events">Upcoming Events</Link></li>
              <li><Link to="/events">Past Events</Link></li>
              <li><Link to="/events">Event Gallery</Link></li>
            </ul>
          </div>

          <div className="sitemap-section">
            <h3>News</h3>
            <ul>
              <li><Link to="/news">Worldtrust News</Link></li>
              <li><Link to="/news">Press Releases</Link></li>
            </ul>
          </div>

          <div className="sitemap-section">
            <h3>Contact Us</h3>
            <ul>
              <li><Link to="/contact">Contact Details</Link></li>
            </ul>
          </div>

          <div className="sitemap-section">
            <h3>Login / Sign up</h3>
            <ul>
              <li><Link to="/login">Login Page</Link></li>
              <li><Link to="/auth-screen">Sign Up Page</Link></li>
              <li><Link to="/register">Sign Up as a Charity</Link></li>
            </ul>
          </div>

          <div className="sitemap-section">
            <h3>FAQ</h3>
            <ul>
              <li><Link to="/faqs">General Questions</Link></li>
            </ul>
          </div>

          <div className="sitemap-section">
            <h3>Legal</h3>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div className="sitemap-section">
            <h3>Careers</h3>
            <ul>
              <li><Link to="/careers">View Careers Opportunities</Link></li>
            </ul>
          </div>

        </div>
      </div>
      </div>
      </section>
    </>
  );
};

export default Sitemap;


